import { useTheme } from '@mui/material/styles';
import { LineChart } from '@mui/x-charts';
import { ChartFrame } from './ChartFrame';
import { calendarTick, type LineChartProps, type AreaChartProps } from './chartTypes';

export const MUILineChart = ({ data, smooth = true, fill = false, ...frame }: LineChartProps) => {
  const theme = useTheme();
  return (
    <ChartFrame {...frame} hasData={data.length > 0}>
      <LineChart
        height={frame.height || 300}
        xAxis={[{ scaleType: 'point', data: data.map((item) => item.date), valueFormatter: calendarTick }]}
        yAxis={[{ min: 0, tickMinStep: 1 }]}
        series={[
          {
            data: data.map((item) => item.value),
            label: frame.title || 'Value',
            color: theme.palette.status.settled,
            curve: smooth ? 'monotoneX' : 'linear',
            area: fill,
            showMark: false,
          },
        ]}
        grid={{ horizontal: true }}
        hideLegend
        margin={{ left: 48, right: 12, top: 12, bottom: 40 }}
        sx={{ '& .MuiAreaElement-root': { fillOpacity: 0.25 } }}
      />
    </ChartFrame>
  );
};

export const MUIAreaChart = (props: AreaChartProps) => <MUILineChart {...props} fill />;
